(function($){
	$(document).ready(function() {
	
		console.log('cur-home-hero.js loaded!');

		var $section = $('.cur-home-hero');
		var sectionId = $section.attr('data-section-id');
		var suffixes = window.heroSuffixes && window.heroSuffixes[sectionId];
		var $h1 = $section.find('h1');
		var $suffix = $section.find('.headline-suffix');
		var $cursor = $section.find('.cursor');
		var current = 0;
		var typeSpeed = 30;
		var deleteSpeed = 10;
		var pauseDuration = 2500;
		var fadeDuration = 1200;

		if (!suffixes || suffixes.length === 0) return;

		function typeOn(text, callback) {
			if (!text) {
				if (callback) setTimeout(callback, pauseDuration);
				return;
			}
			var i = 0;
			$suffix.text('');
			$cursor.removeClass('paused');
			var timer = setInterval(function() {
				$suffix.text(text.substring(0, i + 1));
				i++;
				if (i >= text.length) {
					clearInterval(timer);
					$cursor.addClass('paused');
					if (callback) setTimeout(callback, pauseDuration);
				}
			}, typeSpeed);
		}

		function typeOff(callback) {
			var text = $suffix.text();
			if (!text) {
				if (callback) callback();
				return;
			}
			var i = text.length;
			$cursor.removeClass('paused');
			var timer = setInterval(function() {
				i--;
				$suffix.text(text.substring(0, i));
				if (i <= 0) {
					clearInterval(timer);
					if (callback) callback();
				}
			}, deleteSpeed);
		}

		function cycle() {
			var isLast = (current === suffixes.length - 1);
			var thisSuffix = suffixes[current];
			console.log('cycle start — current:', current, 'isLast:', isLast);

			typeOn(thisSuffix, function() {
				console.log('typeOn callback fired — isLast:', isLast);
				if (isLast) {
					console.log('taking fade path');
					$cursor.addClass('paused');
					$h1.fadeOut(fadeDuration, function() {
						$suffix.text('');
						current = 0;
						$h1.fadeIn(fadeDuration, function() {
							cycle();
						});
					});
				} else {
					console.log('taking typeOff path');
					typeOff(function() {
						current = (current + 1) % suffixes.length;
						cycle();
					});
				}
			});
		}

		$cursor.removeClass('paused');
		setTimeout(function() {
			cycle();
		}, fadeDuration * 0.5);

	});
})(jQuery);